<template>
  <table>
    <tr>
      <td>{{ i18n.database.table.vehicles.columns.license_plate }}</td>
      <td>{{ model.license_plate }}</td>
    </tr>
    <tr>
      <td>{{ i18n.database.table.vehicle_brands.singular }}</td>
      <td>{{ model.brand_name }}</td>
    </tr>
    <tr>
      <td>{{ i18n.database.table.vehicle_models.singular }}</td>
      <td>{{ model.model_name }}</td>
    </tr>
    <tr>
      <td>{{ i18n.database.table.vehicle_types.singular }}</td>
      <td>{{ model.type ? model.type.name : '-' }}</td>
    </tr>
    <tr>
      <td>{{ i18n.database.table.vehicle_colors.singular }}</td>
      <td>{{ model.color ? model.color.name : '-' }}</td>
    </tr>

    <tr v-if="model.transmission_type">
      <td>{{ i18n.database.table.vehicle_transmission_types.singular }}</td>
      <td>{{ model.transmission_type.name }}</td>
    </tr>
    <tr v-if="model.fuel_type">
      <td>{{ i18n.database.table.vehicle_fuel_types.singular }}</td>
      <td>{{ model.fuel_type.name }}</td>
    </tr>

    <tr v-if="model.num_of_seats">
      <td>{{ i18n.database.table.vehicles.columns.num_of_seats }}</td>
      <td>{{ model.num_of_seats }}</td>
    </tr>

    <tr v-for="item in model.accessories_filterable" v-bind:key="item.id">
      <td>{{ item.name }}</td>
      <td>
        <div v-if="item.value">
          <i class="cs-check"></i>
          <span
            v-if="item.tag == ACCESSORY_TAG.TOW_BAR && model.towing_capacity"
          >({{ model.towing_capacity.restrained }}kg)</span>
        </div>

        <i v-else class="cs-close"></i>
      </td>
    </tr>
  </table>
</template>

<script>
import { ACCESSORY_TAG } from "@/models/Accessory";

export default {
  name: "vehicle-specs-list",
  props: ["model"],
  data() {
    return {
      ACCESSORY_TAG: ACCESSORY_TAG
    };
  }
};
</script>
